import { InputSelectChange, InputSelectProps } from './InputSelect.interface';
import { Meta, Story } from '@storybook/react';

import Component from './InputSelect';

export default {
  argTypes: {
    id: {
      table: {
        disable: true,
      },
    },
    label: {
      table: {
        disable: true,
      },
    },
    labelPosition: {
      control: { type: 'select' },
      options: ['left', 'right'],
    },
    name: {
      table: {
        disable: true,
      },
    },
    state: {
      table: {
        disable: true,
      },
    },
    type: {
      table: {
        disable: true,
      },
    },
    value: {
      table: {
        disable: true,
      },
    },
  },
  component: Component,
  title: 'Atoms/InputSelect',
} as Meta<typeof Component>;

const Template: Story<InputSelectProps> = (args) => <Component {...args} />;

const onChangeValue: InputSelectChange = (checked: boolean, value: string) => {
  console.log(value, checked)
}

export const Checkbox = Template.bind({});
Checkbox.args = {
  checked: false,
  id: 'CHECK',
  label: 'Label',
  name: 'check',
  onChangeValue,
  state: 'idle',
  type: 'checkbox',
  value: 'CHECK'
};

export const RadioButton = Template.bind({});
RadioButton.args = {
  checked: true,
  id: 'RADIO',
  label: 'Label',
  name: 'radio',
  onChangeValue,
  state: 'idle',
  type: 'radio',
  value: 'RADIO'
};
